import moment from "moment";

export const getCurrentWeekNumber = () => {
  const today = new Date();
  const weeknumber = moment(today).week();

  return weeknumber;
};

export const getDaysInMonth = (year, month) =>
  new Date(year, month + 1, 0).getDate();
export const getFirstDayOfMonth = (year, month) =>
  new Date(year, month, 1).getDay();
